var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignHorizontalRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M820 976V176h60v800h-60ZM320 766V666h400v100H320ZM80 486V386h640v100H80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignHorizontalRight);
export default __webpack_public_path__ + "static/media/align_horizontal_right.430d9cc0fce8a272b2572cb2a06f6073.svg";
export { ForwardRef as ReactComponent };